export const language = {
  en: {
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Please Entry': 'Please Entry',
    'Delete': 'Delete',
    'Yes': 'Yes',
    'No': 'No',

    'TMS Delivery': 'TMS Delivery',
    'Default': 'Default',
    'Domestic Account': 'Domestic Account',
    'International Account': 'International Account',
    'TMS Account ID': 'TMS Account ID',
    'TMS Account Name': 'TMS Account Name',
    'Shipper No.': 'Shipper No.',
    'Shipper Name': 'Shipper Name',
    'Third Party Delivery': 'Third Party Delivery',
    'Self Delivery': 'Self Delivery',
    'Default Delivery': 'Default Delivery',
    'Set to Default Delivery': 'Set to Default Delivery',
    'International/Domestic': 'International/Domestic',
    'Please Confirm To Delete This Account': 'Please Confirm To Delete This Account',
    'Add Account': 'Add Account',
    'Edit Account': 'Edit Account',
    'Only 1 International Account Is Allowed': 'Only 1 International Account Is Allowed',
    'Account Limit Reached': 'Account Limit Reached',
  },
  zh: {
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Please Entry': '请输入',
    'Delete': '删除',
    'Yes': '是',
    'No': '否',

    'TMS Delivery': 'TMS配送',
    'Default': '默认',
    'Domestic Account': '国内账号',
    'International Account': '国际账号',
    'TMS Account ID': 'TMS账号ID',
    'TMS Account Name': 'TMS账号名称',
    'Shipper No.': '货主编号',
    'Shipper Name': '货主名称',
    'Third Party Delivery': '第三方配送',
    'Self Delivery': '自提',
    'Default Delivery': '默认配送方式',
    'Set to Default Delivery': '设为默认配送方式',
    'International/Domestic': '国际/国内',
    'Please Confirm To Delete This Account': '请确认是否删除该账号',
    'Add Account': '新增账号',
    'Edit Account': '编辑账号',
    'Only 1 International Account Is Allowed': '目前仅允许1个国际账号',
    'Account Limit Reached': '账号过多',
  }
};
